<template>
<div class="content-body tenant-settings">
    <div class="">
        <div>
            <el-row><span style="color:red">计算每小时产量时，对于冲压、注塑等产品，要考虑每模取数</span></el-row>
        </div>
        <!-- 加工费-->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <el-form-item label="工序名称:">
<!--                <el-select size="mini" v-model="dataForm.processName" placeholder="请选择工序名称" clearable @change="getDataList">
                    <el-option v-for="item in PROCESSNAME_VALUE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>-->
                <el-input size="mini" v-model="dataForm.processName" placeholder="请输入工序名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
              <el-button size="mini" :loading="saveDisabled" type="primary" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  plain @click="save()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
              </el-button>
                <el-button size="mini" @click="getDataList()" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  icon="el-icon-search">
                    查询
                </el-button>
<!--                <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">-->
<!--                    新建-->
<!--                </el-button>-->
              <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addHandleNewRow()" icon="el-icon-plus">
                新增
              </el-button>
                <!-- <el-button size="mini" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入订单
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
          <el-table-edit
              v-model="dataList"
              :columns="['roundNo','processName', 'partName','partCode','outputPerHour','equipmentTonnage'
          ,'laborFee','equipmentDepreciation','processingCost','total','other']"
              ref="editTable"
          >
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%" :default-expand-all="false" border :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="partCode" min-width="120px" header-align="center" align="center" label="零件编码">
                  <template slot-scope="{row}">
                    <el-table-edit-cell
                        :row="row"
                        prop="partCode"
                    >
                      <template slot-scope="{rowStates}">
                        <span v-show="!rowStates.editing">{{row.partCode}}</span>
                        <el-input size="mini" v-show="rowStates.editing" v-model="row.partCode" placeholder="请输入零件编码" clearable></el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="partName" min-width="120px" header-align="center" align="center" label="零件名称">
                  <template slot-scope="{row}">
                    <el-table-edit-cell
                        :row="row"
                        prop="partName"
                    >
                      <template slot-scope="{rowStates}">
                        <span v-show="!rowStates.editing">{{row.partName}}</span>
                        <el-input size="mini" v-show="rowStates.editing" v-model="row.partName" placeholder="请输入零件名称" clearable></el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="processName" min-width="120px" header-align="center" align="center" label="工序名称">
                  <template slot-scope="{row}">
                    <el-table-edit-cell
                        :row="row"
                        prop="processName"
                    >
                      <template slot-scope="{rowStates}">
                        <span v-show="!rowStates.editing">{{row.processName}}</span>
                        <el-input size="mini" v-show="rowStates.editing" v-model="row.processName" placeholder="请输入工序名称" clearable></el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="outputPerHour" header-align="center" align="right" label="每小时产量">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="outputPerHour"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.outputPerHour | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.outputPerHour" placeholder="每小时产量"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="equipmentTonnage" header-align="center" align="right" label="设备吨位">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="equipmentTonnage"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.equipmentTonnage  | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.equipmentTonnage" placeholder="设备吨位"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="laborFee" header-align="center" align="right" label="劳务费">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="laborFee"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.laborFee | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.laborFee" placeholder="劳务费"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="equipmentDepreciation" header-align="center" align="right" label="设备折旧费">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="equipmentDepreciation"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.equipmentDepreciation | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.equipmentDepreciation" placeholder="设备折旧费"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
              <el-table-column prop="other" header-align="center" align="right" label="其他">
                <template slot-scope="{ row }">
                  <el-table-edit-cell
                      :row="row"
                      prop="other"
                  >
                    <template slot-scope="{ rowStates}">
                      <span v-show="!rowStates.editing">{{row.other | digit3}}</span>
                      <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.other" type="textarea" :rows="3" placeholder="其他"></ctl-number>
                    </template>
                  </el-table-edit-cell>
                </template>
              </el-table-column>
                <el-table-column prop="processingCost" header-align="center" align="right" label="加工成本">
                    <template slot-scope="scope">
                        {{scope.row.processingCost | digit3}}
                    </template>
                </el-table-column>
                <el-table-column prop="total" header-align="center" align="right" label="合计">
                    <template slot-scope="scope">
                        {{scope.row.total | digit3}}
                    </template>
                </el-table-column>
                <el-table-column prop="roundNo" width="150" header-align="center" align="right" label="报价轮次">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-show="scope.row.id !==''" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" v-show="scope.row.id !==''" size="small" :disabled="viewFlag != 'view'? false :true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
          </el-table-edit>
            <!-- 分页 -->
            <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @getDataListAll="getDataListAll"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    addPartPrice,
    editPartPrice,
    createProcessCostBatch,
    fetchProcessCostList,
    deleteProcessCost,
    getQuotationDetail
} from "@/controller/quotation";
import CtlNumber from '@/views/common/ctl-number'
import {
    PROCESSNAME_VALUE,
    getLabelByValue
} from '@/utils/const'
import AddOrUpdate from "./quotationProcessCost-add-or-update";
import moment from "moment";
// require('@/mock/mockTech');
export default {
    props: {
        roundNo: Number,
        dataFromParent:Object
    },
    data() {
        return {
          rowNum:1,
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                rfqId: '',
                rfqPartId: "",
                rfqSupplierId: "",
                roundNo: "",
                processName: "",
            },
            viewFlag: '',
            PROCESSNAME_VALUE: PROCESSNAME_VALUE,
            getLabelByValue: getLabelByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            saveDisabled:false,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
        };
    },
    computed: {
      editTable() {
        return this.$refs.editTable
      },
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    filters:{
      digit3:function (data){
          if (data == null ){
            return data
          }
          
          if(Number.isNaN(Number(data))){
            return null
            }
        data = Number(data).toFixed(3)
        return Number(data)
        },
    },
    components: {
        AddOrUpdate,
      CtlNumber
    },
    // mounted() {
    //     this.getDataList();
    // },
    methods: {
      //新一行
      getNewRowData() {
        return {
          'id':'',
          'partCode':'',
          'partName':'',
          'rfqId': this.dataForm.rfqId,
          'rfqPartId': this.dataForm.rfqPartId,
          'rfqSupplierId': this.dataForm.rfqSupplierId,
          'roundNo':this.dataForm.roundNo!==null ? this.dataForm.roundNo:'0',
          'processName':'',
          'outputPerHour':'',
          'equipmentTonnage':'',
          'laborFee':'',
          'equipmentDepreciation':'',
          'processingCost':'',
          'total':'',
          'other':'',
          'rowNum':this.rowNum
        }
      },
        // 新增行
        addHandleNewRow() {
          const newRow = this.getNewRowData()
          this.editTable.newRows([newRow])
          this.rowNum += 1
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        processNameFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(PROCESSNAME_VALUE, value)
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            fetchProcessCostList({
                pageNo: 1,
                pageSize: -1,
                ...this.dataForm,
            }).then((data) => {
                // console.log(data, 'data')
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        // 获取数据列表
        getDataListAll() {
            this.dataListLoading = true;
            fetchProcessCostList({
                pageNo: 1,
                pageSize: -1,
                ...this.dataForm,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.saveSum(data.body.records)
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        saveSum(dataListAll){
            let sum = 0;
            if(dataListAll !== 0){
                dataListAll.forEach((item) => {
                    sum += this.fixedNumber(item.processingCost);
                });
            }
            let params = this.dataFromParent
            params.rfqId = this.dataFromParent.rfqId
            params.processingCost = sum
            // 制造成本小计(D=A+B+C)
            params.productionCostSum = this.fixedNumber(params.materialCost) + this.fixedNumber(params.outsidePartCost) 
                + this.fixedNumber(params.processingCost)
            // 产品单价(J=D+H+I+K+L)
            params.productUnitPrice = this.fixedNumber(params.productionCostSum) + this.fixedNumber(params.midiumCostSum)
                + this.fixedNumber(params.profit) + this.fixedNumber(params.packageFee) 
                + this.fixedNumber(params.transportFee) 
            // 产品价格总计
            params.feeCostSum = this.fixedNumber(params.productUnitPrice) + this.fixedNumber(params.toolsPartAllocation)
                + this.fixedNumber(params.designPartAllocation) 
            if (params.id) {
                editPartPrice(params).then(data => {
                    if (data && data.code === '00') {
                        // this.dataForm.id = data.body.id;
                        // this.dataForm = data.body;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                addPartPrice(params).then(data => {
                    if (data && data.code === '00' && data.body) {
                        this.dataFromParent.id = data.body.id;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })

                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm, this.dataFromParent.rfqId)
            })
        },

      //保存
      save(){

        var ins =[]
        var upd=[]
        this.dataList.forEach(value => {
          if (value.id !==''){
            upd.push(value)
          }else {
            ins.push(value)
          }
        })

        if (ins.length > 0 ){
          var params = {
            "list":ins,
            "rfqId": this.dataForm.rfqId,
            "subcompanyId":this.dataFromParent.subcompanyId
          }
          // 创建零件
          this.saveDisabled = true
          createProcessCostBatch(params)
              .then((data) => {
                if (data && data.code === "00") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                  });
                    this.$nextTick(() => {
                    this.getDataListAll();
                    })
                } else {
                  this.$message.error(data.msg);
                }
                this.getDataList()
                setTimeout(() => {
                    this.saveDisabled = false
                }, 3000)
              })
              .catch((error) => {
                console.log(error);
              });
        }
        // if (upd.length > 0 ){
        //   var params = {
        //     "list":upd
        //   }
        //   // 更新零件
        //   editProcessCostBatch(params)
        //       .then((data) => {
        //         if (data && data.code === "00") {
        //           this.$message({
        //             message: "操作成功",
        //             type: "success",
        //             duration: 1500,
        //           });
        //         } else {
        //           this.$message.error(data.msg);
        //         }
        // this.getDataList()
        //       })
        //       .catch((error) => {
        //         console.log(error);
        //       });
        // }


      },

        // 删除
        deleteHandle(row) {

          if (row.id === ''){
            var a = []
            a.push(row)
            this.editTable.delRows(a)
          }else {
            if (row && row.rfqId) {
               getQuotationDetail({}, row.rfqId).then(data => {
                 if (data && data.code === '00') {
                     if("2" != data.body.rfqStatus) {
                       this.$message.warning("询价单不是询价中状态，不允许删除报价相关信息")
                     } else {
                       this.$confirm(`确定进行删除操作?`, '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                       }).then(() => {
                         deleteProcessCost({}, row.id).then(data => {
                           if (data && data.code === '00') {
                             this.$message({
                               message: '操作成功',
                               type: 'success',
                               duration: 1500,
                               onClose: () => {
                                 this.getDataList()
                               }
                             })
                             this.$nextTick(() => {
                                 this.getDataListAll();
                             })
                           } else {
                             this.$message.error(data.msg)
                           }
                         })
                       })
                     }
                 }
               })
            }
          }
        },
    },
};
</script>

<style lang="scss">
.input-width {
    width: 155px;
}

.button-danger {
    color: #F56C6C;
}

.fr {
    float: right;
}
</style>
